import { gql } from '@apollo/client'

export default gql(`
  query getCategories($searchKey: String $limit: Int $offset: Int $project: String){
    getContentByField(
        searchKey: $searchKey,
        field: ASSET_CATEGORY,
        offset: $offset,
        limit: $limit
        project: $project
      ) {
        items{
          name
          id: key
        }
    }
  }
  `
)
